export default {
    READY: "READY",
    SUCCESS: "SUCCESS",
    EXISTING: "EXISTING",
    ERROR: "ERROR"
}
